import React, { useState } from 'react';
import {
  Box,
  Button,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Typography,
} from '@mui/material';

export interface ScormCourseForm {
  uploaded_file: string;
}

interface FormDialogProps {
  open: boolean;
  onClose: () => void;
  errorMessage?: string;
  status?: string;
  errorDetails?: any;
}

const ScormLoadingDialog: React.FC<FormDialogProps> = ({
  open,
  onClose,
  errorMessage,
  status,
  errorDetails,
}) => {
  const hasError = !!errorMessage;
  const [showDetails, setShowDetails] = useState(false);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        {hasError ? 'Learning Package Load Failed' : 'Learning Package Loading in Progress'}
        <Divider sx={{ mt: 2, mb: 0 }} />
      </DialogTitle>
      <DialogContent sx={{ pb: 1 }}>
        {hasError ? (
          <>
            <DialogContentText>
              There was an error loading your learning package. Please try uploading the package
              again or contact support if the issue persists.
            </DialogContentText>
            <Box sx={{ mt: 2, p: 2, bgcolor: '#f1f1f1', borderRadius: 1 }}>
              <Typography variant='body2' color='#162540'>
                <strong>Error message: </strong> {errorMessage}
              </Typography>
              {errorDetails && (
                <>
                  <Button size='small' onClick={() => setShowDetails(!showDetails)} sx={{ mt: 1 }}>
                    {showDetails ? 'Hide Error Details' : 'Show Error Details'}
                  </Button>
                  <Collapse in={showDetails}>
                    <Box
                      sx={{
                        mt: 1,
                        p: 1,
                        bgcolor: '#f8f8f8',
                        borderRadius: 1,
                        maxHeight: '200px',
                        overflow: 'auto',
                      }}
                    >
                      <pre style={{ whiteSpace: 'pre-wrap', fontSize: '0.75rem' }}>
                        {JSON.stringify(errorDetails, null, 2)}
                      </pre>
                    </Box>
                  </Collapse>
                </>
              )}
            </Box>
          </>
        ) : (
          <DialogContentText>
            Your learning package is being loaded in the background. The course will reload when it
            is ready. Course edits cannot be saved until the learning package completes loading.
          </DialogContentText>
        )}
        <Divider sx={{ mt: 2, mb: 0 }} />
      </DialogContent>
      <DialogActions>
        <Box sx={{ width: '100%', pb: 2, px: 2 }}>
          <Button onClick={onClose} variant='contained' sx={{ width: '100%' }}>
            Close
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
export default ScormLoadingDialog;
